module.exports = __webpack_public_path__ + "static/media/resource-8.f61d5aa5.png";